export class ObjectsUtils {
    public static deepCopy(obj) {
        let copy;

        // Handle the 3 simple types, and null or undefined
        // tslint:disable:max-line-length
        if (null == obj || 'object' != typeof obj) {
            return obj;
        }

        // handle Date
        if (obj instanceof Date) {
            copy = new Date();
            copy.setTime(obj.getTime());
            return copy;
        }

        // handle Array
        if (obj instanceof Array) {
            copy = [];
            for (let i = 0, len = obj.length; i < len; i++) {
                copy[i] = ObjectsUtils.deepCopy(obj[i]);
            }
            return copy;
        }

        // handle Object
        if (obj instanceof Object) {
            copy = {};
            for (const attr in obj) {
                if (obj.hasOwnProperty(attr)) {
                    copy[attr] = ObjectsUtils.deepCopy(obj[attr]);
                }
            }
            return copy;
        }

        throw new Error('Unable to copy obj! Its type isn\'t supported.');
    }

    static replacePointerValue(pointer: any, newData: any) {

        if (!pointer || typeof pointer !== 'object') {
            throw new Error('Pointer must be an object');
        }

        // remove properties from filterData_pointer that are not in data
        for (const key in pointer) {
            if (pointer.hasOwnProperty(key) && !(key in newData)) {
                delete pointer[key];
            }
        }

        for (const key in newData) {
            if (newData.hasOwnProperty(key)) {
                if (newData[key] !== undefined && newData[key] !== null) {
                    pointer[key] = newData[key];
                } else {
                    delete pointer[key];
                }
            }
        }
    }

    static updatePointerValue(pointer: any, newData: any) {
        if (!pointer || typeof pointer !== 'object') {
            throw new Error('Pointer must be an object');
        }

        if (newData) {
            return;
        }

        // add or update properties in pointer that are defined in newData, not change the others
        for (const key in newData) {
            if (newData.hasOwnProperty(key)) {
                if (newData[key] !== undefined && newData[key] !== null) {
                    pointer[key] = newData[key];
                }
            }
        }

    }
}
